import { gql } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';

const GET_COUNTRY_EVENTS_QUERY = gql`
  query getDitCountryEvents(
    $countryIsoCode: String!
    $sourceFiles: String
    $sourceType: String
    $status: String
    $limit: Int
  ) {
    ditCountryEvents(
      countryIsoCode: $countryIsoCode
      sourceFiles: $sourceFiles
      sourceType: $sourceType
      status: $status
      limit: $limit
    ) {
      id
      status
      message
      sourceTypeId
      updatedAt
      sourceFiles {
        filename
      }
    }
  }
`;

export const useDitGetCountryEvents = () => {
  const [getEvents, { data, loading, error }] = useLazyQuery(GET_COUNTRY_EVENTS_QUERY);

  return {
    getDitCountryEvents: async ({
      countryIsoCode,
      sourceFiles,
      sourceType,
      status,
      limit = 100,
    }) => {
      const variables = {
        countryIsoCode,
        ...(sourceFiles && { sourceFiles }),
        ...(sourceType && { sourceType }),
        ...(status && { status }),
        limit,
      };
      return await getEvents({ variables });
    },
    countryEvents: data?.ditCountryEvents || [],
    loading,
    error,
  };
};
